import { render } from "./InnovationAdvancedSearch.vue?vue&type=template&id=47a221a6&scoped=true"
import script from "./InnovationAdvancedSearch.vue?vue&type=script&lang=js"
export * from "./InnovationAdvancedSearch.vue?vue&type=script&lang=js"

import "./InnovationAdvancedSearch.vue?vue&type=style&index=0&id=47a221a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47a221a6"

export default script